module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v("Home")]), _vm._v(" "), _c('p', [_vm._v("Plan Meal!")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_vm._v("Save info")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06521346"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 126
// module chunks = 0